import type { ConversationRef } from "./chatState";

export type ConversationCapabilities = {
  isE2E: boolean;
  supportsTopics: boolean;
  supportsRoles: boolean;
  supportsReadReceipts: boolean;
  isEphemeral: boolean;
  /** DM и workspace topic: вложения (изображения) в композере. */
  supportsComposerAttachments: boolean;
  /** DM: reply, реакции, свайп; workspace — reply/реакции без read receipts. */
  supportsMessageActions: boolean;
};

const DM_CAPABILITIES: ConversationCapabilities = {
  isE2E: true,
  supportsTopics: false,
  supportsRoles: false,
  supportsReadReceipts: true,
  isEphemeral: false,
  supportsComposerAttachments: true,
  supportsMessageActions: true,
};

/** Workspace topic: текст и серверные изображения; reply и реакции через workspace.msg.* / workspace.reaction.*. */
const WORKSPACE_TOPIC_PLACEHOLDER: ConversationCapabilities = {
  isE2E: false,
  supportsTopics: true,
  supportsRoles: true,
  supportsReadReceipts: false,
  isEphemeral: false,
  supportsComposerAttachments: true,
  supportsMessageActions: true,
};

/** Personal vault: client secretbox; no relay read receipts / presence. */
const VAULT_CAPABILITIES: ConversationCapabilities = {
  isE2E: true,
  supportsTopics: false,
  supportsRoles: false,
  supportsReadReceipts: false,
  isEphemeral: false,
  supportsComposerAttachments: true,
  supportsMessageActions: true,
};

const NONE_CAPABILITIES: ConversationCapabilities = {
  isE2E: false,
  supportsTopics: false,
  supportsRoles: false,
  supportsReadReceipts: false,
  isEphemeral: false,
  supportsComposerAttachments: false,
  supportsMessageActions: false,
};

export function conversationCapabilitiesFor(ref: ConversationRef | null): ConversationCapabilities {
  if (!ref) return NONE_CAPABILITIES;
  if (ref.kind === "dm") return DM_CAPABILITIES;
  if (ref.kind === "vault") return VAULT_CAPABILITIES;
  return WORKSPACE_TOPIC_PLACEHOLDER;
}
